import allBlogs from "../../data/AllBlogs";
import { ADDBLOGS, DELETEBLOGS } from "./actionTypes";

const blogReducer = (state = allBlogs, action) => {
  switch (action.type) {
    case ADDBLOGS:
      return [...state, action.payload];
    case DELETEBLOGS:
      return state.filter((blog) => {
        if (blog.id !== action.payload) {
          return blog;
        }
      });
    default:
      return state;
  }
};

export default blogReducer;
